module.exports = __webpack_public_path__ + "img/ic-profile@2x.2c0699c7.png";